import { e_switchListsbBy, I_RootState } from './interfaces';
import * as actionTypes from './actionTypes';

const TravelPavilionGroupID = new URLSearchParams(window.location.search).get(
    'TravelPavilionGroupID'
);

const initialState: I_RootState = {
    FilterItems: [
        {
            filterBy: 'TravelType',
            text: '團體',
            value: 1,
            subValue: '',
        },
        {
            filterBy: 'TravelType',
            text: '團體自由行',
            value: 2,
            subValue: '',
        },
    ],
    TempFilterItems: [],
    SortListBy: TravelPavilionGroupID ? undefined : 3, // 初始設為依出發日
    SwitchListBy: e_switchListsbBy.Cards, // 初始設為依行程列表 bbc 是 Cards 開始
    TagFiltersShow: [], // 特色標籤展開項目，預設都不展開
    TempTagFiltersShow: [], // 特色標籤展開項目，預設都不展開
    PackageInfo: [],
    GroupListInfo: {
        data: undefined,
        isLoading: true,
    },
    GroupListInfoM: {
        data: undefined,
        isLoading: true,
        PageSize: 10,
    },
    SingleGroupListInfo: {
        data: undefined,
        isLoading: true,
    },
    SingleGroupListInfoM: {
        data: undefined,
        isLoading: true,
        PageSize: 10,
    },
    ChangeItem: false,
    Tags: '',
    Trigger: '',
    callJson: {
        BuName: '',
        Data: [],
    },
};

const reducer = (state: I_RootState = initialState, action: any) => {
    switch (action.type) {
        case actionTypes.SET_GROUPLISTINFO:
            return { ...state, GroupListInfo: { ...state.GroupListInfo, isLoading: true } };
        case actionTypes.SET_GROUPLISTINFO_SUCCESS:
            return { ...state, GroupListInfo: { data: action.payload, isLoading: false } };
        case actionTypes.SET_GROUPLISTINFOM:
            return {
                ...state,
                GroupListInfoM: {
                    ...state.GroupListInfoM,
                    PageSize: action.payload.PageSize,
                    isLoading: true,
                },
            };
        case actionTypes.SET_GROUPLISTINFOM_SUCCESS:
            return {
                ...state,
                GroupListInfoM: { ...state.GroupListInfoM, data: action.payload, isLoading: false },
            };
        case actionTypes.SET_SINGLEGROUPLISTINFO:
            return {
                ...state,
                SingleGroupListInfo: { ...state.SingleGroupListInfo, isLoading: true },
            };
        case actionTypes.SET_SINGLEGROUPLISTINFO_SUCCESS:
            return { ...state, SingleGroupListInfo: { data: action.payload, isLoading: false } };
        case actionTypes.SET_SINGLEGROUPLISTINFOM:
            return {
                ...state,
                SingleGroupListInfoM: {
                    ...state.SingleGroupListInfoM,
                    PageSize: action.payload.PageSize,
                    isLoading: true,
                },
            };
        case actionTypes.SET_SINGLEGROUPLISTINFOM_SUCCESS:
            return {
                ...state,
                SingleGroupListInfoM: {
                    ...state.SingleGroupListInfoM,
                    data: action.payload,
                    isLoading: false,
                },
            };
        case actionTypes.SET_DEPTHINFO_SUCCESS:
            return { ...state, DepthInfo: action.payload };
        case actionTypes.SET_FILTERITEMS:
            return { ...state, FilterItems: action.payload };
        case actionTypes.SET_TEMPFILTERITEMS:
            return { ...state, TempFilterItems: action.payload };
        case actionTypes.SET_SORTLISTBY:
            return { ...state, SortListBy: action.payload };
        case actionTypes.SET_SWITCHLISTBY:
            return { ...state, SwitchListBy: action.payload };
        case actionTypes.SET_TAGFILTERS_SHOW:
            return { ...state, TagFiltersShow: action.payload };
        case actionTypes.SET_TEMPTAGFILTERS_SHOW:
            return { ...state, TempTagFiltersShow: action.payload };
        case actionTypes.SET_PAGESIZEM:
            return { ...state, PageSizeM: action.payload };
        case actionTypes.SET_CHANGEITEM:
            return { ...state, ChangeItem: action.payload };
        case actionTypes.SET_TAGS:
            return { ...state, Tags: action.payload };
        case actionTypes.SET_TRIGGER:
            return { ...state, Trigger: action.payload };
        case actionTypes.SET_CALLJSON:
            return { ...state, callJson: { ...action.payload } };
        default:
            return state;
    }
};

export default reducer;
